import { isUndefined } from 'lodash'

export default {
  computed: {
    hasPageSize() {
      return this.pageSize !== 0 && !isUndefined(this.pageSize)
    },
    id() {
      return this.$get('id')
    },
    limit: {
      get() {
        return this.$get('limit')
      },
      set(limit) {
        const pager = { ...this.pager }
        const newOffset = Math.floor(pager.offset / limit) * limit
        pager.limit = limit
        pager.offset = newOffset
        this.pager = pager
        // ListContainer listafrissites event alapu
        EventBus.$emit(`apply-filter-${this.id}`, { id: this.id, type: 'button' })
      },
    },
    offset: {
      get() {
        return this.$get('offset') || 0
      },
      set(offset) {
        const pager = { ...this.pager }
        pager.offset = offset
        this.pager = pager
      }
    },
    pager: {
      get() {
        return this.$get('pager')
      },
      set(pager) {
        this.$dispatch('setPager', { pager })
        this.updateLocalStore({ prop: 'pager', value: pager })
      }
    },
    total: {
      get() {
        return this.$get('total')
      },
      set(total) {
        const pager = { ...this.pager }
        pager.total = total
        this.pager = pager
      }
    },
  },
  methods: {
    limitOption(count) {
      return this.$i18n.interpolate(this.$i18n.t('${count}_row_per_page'), {
        count,
      })
    },
  },
}